module.exports = __webpack_public_path__ + "img/rainbow_unicorn.0abd7a30.jpg";